import { React, lazy, Suspense, useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
//import { Routes, Route, useLocation } from "react-router-dom";

//Components
import LazyLoading from "./components/shared/LazyLoading/LazyLoading";
import Layout from "./components/layout/Layout/Layout";

import PrivateRoute from "./components/shared/PrivateRoute";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

//Seo
//import Seo from "./components/Meta";

//Pages
const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const UploadPage = lazy(() => import("./pages/UploadPage/UploadPage"));
const ForumPage = lazy(() => import("./pages/ForumPage/ForumPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage/ProfilePage"));
const LibPage = lazy(() => import("./pages/LibPage/LibPage"));
const BookmarksPage = lazy(() => import("./pages/BookmarksPage/BookmarksPage"));
const Register = lazy(() => import("./pages/RegisterPage/RegisterPage"));
const Login = lazy(() => import("./pages/LoginPage/LoginPage"));
const ErrorPage = lazy(() => import("./pages/ErrorPage/Error404/Error404"));

const App = () => {
  //const location = useLocation();

  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    // Имитация загрузки начальных данных/ресурсов
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 0); // Замените на реальную загрузку данных

    return () => clearTimeout(timer);
  }, []);

  if (isInitialLoading) {
    return <LazyLoading fullScreen={true} />;
  }

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <Suspense fallback={<LazyLoading />}>
                <HomePage />
              </Suspense>
            }
          />
          <Route
            path="register"
            element={
              <Suspense fallback={<LazyLoading />}>
                <Register />
              </Suspense>
            }
          />
          <Route
            path="login"
            element={
              <Suspense fallback={<LazyLoading />}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="profile/*"
            element={
              <PrivateRoute>
                <Suspense fallback={<LazyLoading />}>
                  <ProfilePage />
                </Suspense>
              </PrivateRoute>
            }
          />
          <Route
            path="bookmark"
            element={
              <Suspense fallback={<LazyLoading />}>
                <BookmarksPage />
              </Suspense>
            }
          />
          <Route
            path="lib"
            element={
              <Suspense fallback={<LazyLoading />}>
                <LibPage />
              </Suspense>
            }
          />
          <Route
            path="settings/"
            element={
              <Suspense fallback={<LazyLoading />}>
                <SettingsPage />
              </Suspense>
            }
          />
          <Route
            path="forum/"
            element={
              <Suspense fallback={<LazyLoading />}>
                <ForumPage />
              </Suspense>
            }
          />
          <Route
            path="upload/*"
            element={
              <Suspense fallback={<LazyLoading />}>
                <UploadPage />
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Suspense fallback={<LazyLoading />}>
                <ErrorPage status="404" />
              </Suspense>
            }
          />
        </Route>
        <Route path="/load" element={<LazyLoading />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
